module.exports = __webpack_public_path__ + "img/Morbida_closed.0c204c9c.png";